import { fromJS, List } from 'immutable';
import { SEARCH } from '../../../constants/configTypes';
import { CRM_OBJECT } from '../../../constants/dataTypes';
import { DESC } from '../../../constants/sortOrder';
import { IN, NOT_IN } from '../../../constants/operators';
import { buildDrilldownReport } from '../report';
import { defaultProperties } from '../../drilldown/defaultProperties';
//@ts-expect-error Untyped dependency
import { HUBSPOT_CRM_OBJECTS_BY_ID } from '../../../crmObjects/utils';
//@ts-expect-error Untyped dependency
import { getCrmObjectData } from '../../../crmObjects/utils';
import { getReportChartType } from '../../../report/reportGetters';
import { VENN } from '../../../constants/chartTypes';
const CRM_SEARCH_LIST_IDS = 'hs_crm_search.ilsListIds';
const isSupported = report => {
  return getReportChartType(report) === VENN; // TODO: use the isVennChart util
};
const parseDrilldownKeys = keys => {
  const inclusiveListIdsStr = String(keys.get(1));
  const exclusiveListIdsStr = String(keys.get(2));
  const objectTypeID = String(keys.get(3));
  const inclusiveListIds = inclusiveListIdsStr ? inclusiveListIdsStr.split(',') : [];
  const exclusiveListIds = exclusiveListIdsStr ? exclusiveListIdsStr.split(',') : [];
  return {
    inclusiveListIds,
    exclusiveListIds,
    objectTypeID
  };
};
const buildVennCustomFilters = (inclusiveListIds, exclusiveListIds) => {
  const customFilters = [];
  inclusiveListIds.forEach(listId => {
    if (listId) {
      customFilters.push(fromJS({
        property: CRM_SEARCH_LIST_IDS,
        operator: IN,
        values: [listId]
      }));
    }
  });
  if (exclusiveListIds.length > 0) {
    customFilters.push(fromJS({
      property: CRM_SEARCH_LIST_IDS,
      operator: NOT_IN,
      values: exclusiveListIds
    }));
  }
  return customFilters;
};
const resolveVennMetrics = async objectTypeID => {
  const dataType = HUBSPOT_CRM_OBJECTS_BY_ID.get(objectTypeID);
  const rawMetrics = defaultProperties[dataType];
  let metrics = rawMetrics === null || rawMetrics === void 0 ? void 0 : rawMetrics.map(property => ({
    property,
    metricTypes: List()
  }));
  if (!metrics || metrics.length === 0) {
    const objectData = await getCrmObjectData(objectTypeID);
    const defaultSearchPropertyNames = objectData.get('defaultSearchPropertyNames');
    if (defaultSearchPropertyNames) {
      metrics = defaultSearchPropertyNames.toJS().map(property => ({
        property,
        metricTypes: List()
      }));
    } else {
      metrics = [{
        property: 'hs_object_id',
        metricTypes: List()
      }];
    }
  }
  return metrics || [];
};
const buildVennDrilldownConfig = (report, objectTypeID, customFilters, metrics) => {
  return report.get('config').set('configType', SEARCH).set('dataType', CRM_OBJECT).set('objectTypeId', objectTypeID).set('filters', fromJS(Object.assign({}, report.getIn(['config', 'filters'], {}).toJS(), {
    custom: customFilters
  }))).set('metrics', fromJS(metrics)).set('dimensions', fromJS([])).set('limit', 50).set('offset', 0).set('sort', fromJS([{
    property: 'hs_createdate',
    order: DESC
  }]));
};
const generate = async (report, keys, options) => {
  const {
    inclusiveListIds,
    exclusiveListIds,
    objectTypeID
  } = parseDrilldownKeys(keys);
  const customFilters = buildVennCustomFilters(inclusiveListIds, exclusiveListIds);
  const metrics = await resolveVennMetrics(objectTypeID);
  const drilledConfig = buildVennDrilldownConfig(report, objectTypeID, customFilters, metrics);
  return buildDrilldownReport(report, drilledConfig, options);
};
export default {
  isSupported,
  generate,
  trackingName: 'venn_diagram'
};